import { useEffect, useState } from 'react';

export function useDelayedUnmount(isOpen) {
  const [displayed, setDisplayed] = useState(isOpen);
  const [openedClass, setOpenedClass] = useState(isOpen);

  useEffect(() => {
    if (isOpen) {
      setDisplayed(true);
      let raf2;
      const raf1 = requestAnimationFrame(() => {
        raf2 = requestAnimationFrame(() => setOpenedClass(true));
      });
      return () => {
        cancelAnimationFrame(raf1);
        cancelAnimationFrame(raf2);
      };
    }
    setOpenedClass(false);
    const timeout = setTimeout(() => setDisplayed(false), 300);
    return () => clearTimeout(timeout);
  }, [isOpen]);

  return [displayed, openedClass];
}

export default useDelayedUnmount;
